<template>
  <el-form-item :label="currentField.label">
    <el-row>
      <el-col>
        <el-checkbox-group
          v-model="checkedList"
          :min="currentField.min"
          :max="currentField.max"
          @change="handleChange"
        >
          <el-row>
            <el-col>
              <el-checkbox
                :span="24"
                v-for="item in currentField.options"
                :key="item.optionValue.trim()"
                :label="item.optionValue.trim()"
                :disabled="item.disabled"
                :value="item.optionLabel.trim()"
              >
                {{ item.optionLabel }}
              </el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
import fetchData from '@/api/fetch-data'
export default {
  name: 'Checkbox',
  props: ['currentField'],
  data() {
    return {
      checkedList: []
    }
  },
  mounted() {
    // if (this.currentField.value && Array.isArray(this.currentField.value)) {
    //   this.checkedList = this.currentField.value
    // }
    if (this.currentField.isFromUrl) {
      let dataUrl = this.currentField.dataUrl
      let valueField = this.currentField.valueField
      let labelField = this.currentField.labelField
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField)
      promise.then((data) => {
        this.currentField.options = data
      })
    }
  },
  methods: {
    handleChange() {
      this.currentField.value = this.checkedList
    }
  }
}
</script>

<style>
.el-checkbox-group {
  font-size: 14px;
}
</style>
